export { default as AdDetailModel } from './model'
